export interface IDeliveryAddress {
    firstName: string;
    lastName: string;
    company: string;
    street: string;
    streetNumber: string;
    addressLine2: string;
    zip: string;
    city: string;
    state: string;
    country: string;
    phoneNumber: string;
    deliveryInstructions: string;
    useOwnAddress: boolean;
}
export const initialDeliveryAddress: IDeliveryAddress = {
    firstName: '',
    lastName: '',
    company: '',
    street: '',
    streetNumber: '',
    addressLine2: '',
    zip: '',
    city: '',
    state: '',
    country: '',
    phoneNumber: '',
    deliveryInstructions: '',
    useOwnAddress: false,
};
